var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["generateHTTPClient"]: () => __WEBPACK_EXTERNAL_MODULE__cloudbase_wx_cloud_client_sdk_7708af81__.generateHTTPClient });